module.exports = __webpack_public_path__ + "img/fa03.9d0cd53c.jpg";